// Gerado por scripts/build-icons.mjs — não editar manualmente.
// Módulo SÓ de dados: sem React/JSX, seguro para Node, APIs e backends.
// Importe via "react-bancos/data".

export interface BankData {
  /** Identificador do arquivo/ícone (ex.: "nubank") */
  slug: string;
  /** Nome da instituição (ex.: "Nubank") */
  name: string;
  /** Código de compensação Bacen (ex.: "260") ou null */
  compe: string | null;
  /** Cor de fundo do ícone (ex.: "#820ad1") ou null */
  color: string | null;
}

/** Lista completa das instituições disponíveis, em ordem alfabética de slug. */
export const banksData: BankData[] = [
  { slug: "99pay", name: "99Pay", compe: null, color: "#fedf00" },
  { slug: "abcbrasil", name: "Banco ABC Brasil", compe: "246", color: "#1e1e1e" },
  { slug: "adyen", name: "Adyen", compe: null, color: "#ffffff" },
  { slug: "agibank", name: "Agibank", compe: "121", color: "#266bff" },
  { slug: "ailos", name: "Ailos", compe: "085", color: "#ffffff" },
  { slug: "alelo", name: "Alelo", compe: null, color: "#008060" },
  { slug: "almah", name: "Almah Conta", compe: null, color: "#1c1444" },
  { slug: "amazon", name: "Cartão Amazon", compe: null, color: "#ffffff" },
  { slug: "amazonprime", name: "Cartão Amazon Prime", compe: null, color: "#0779ff" },
  { slug: "americanas", name: "Cartão Americanas", compe: null, color: "#f80032" },
  { slug: "amex", name: "American Express", compe: null, color: "#006fcf" },
  { slug: "applepay", name: "Apple Pay", compe: null, color: "#ffffff" },
  { slug: "arbi", name: "Banco Arbi", compe: "213", color: "#ffffff" },
  { slug: "artta", name: "ARTTA", compe: null, color: "#ffffff" },
  { slug: "asaas", name: "Asaas", compe: "461", color: "#0038e5" },
  { slug: "atacadao", name: "Cartão Atacadão", compe: null, color: "#ffffff" },
  { slug: "avenue", name: "Avenue", compe: null, color: "#002820" },
  { slug: "azul", name: "Cartão Azul", compe: null, color: "#ffffff" },
  { slug: "bancodaamazonia", name: "Banco da Amazônia", compe: "003", color: "#003c2d" },
  { slug: "bancodobrasil", name: "Banco do Brasil", compe: "001", color: "#fee60e" },
  { slug: "bancodobrasilinfinite", name: "Ourocard Visa Infinite", compe: null, color: "#0d0d0d" },
  { slug: "bancodonordeste", name: "Banco do Nordeste", compe: "004", color: "#a6193c" },
  { slug: "bancomaster", name: "Banco Master", compe: "243", color: "#0d2a5c" },
  { slug: "banese", name: "Banese", compe: "047", color: "#00622a" },
  { slug: "banestes", name: "Banestes", compe: "021", color: "#004b8d" },
  { slug: "bankly", name: "Bankly", compe: "332", color: "#347bff" },
  { slug: "bankofamerica", name: "Bank of America Merrill Lynch", compe: "755", color: "#ffffff" },
  { slug: "banpara", name: "Banpará", compe: "037", color: "#ea1c24" },
  { slug: "banrisul", name: "Banrisul", compe: "041", color: "#010050" },
  { slug: "banrisulinfinite", name: "Banrisul Visa Infinite", compe: null, color: "#0d0d0d" },
  { slug: "bari", name: "Banco Bari", compe: null, color: "#000000" },
  { slug: "beesbank", name: "BEES Bank", compe: null, color: "#ffffff" },
  { slug: "binance", name: "Binance", compe: null, color: "#ffffff" },
  { slug: "bitget", name: "Bitget", compe: null, color: "#ffffff" },
  { slug: "bitso", name: "Bitso", compe: null, color: "#ffffff" },
  { slug: "bkbank", name: "BK Bank", compe: null, color: "#ffffff" },
  { slug: "bmg", name: "Banco BMG", compe: "318", color: "#f26321" },
  { slug: "bmp", name: "BMP Money Plus", compe: "274", color: "#0d0d12" },
  { slug: "bnpparibas", name: "Banco BNP Paribas Brasil", compe: "752", color: "#00915a" },
  { slug: "bradesco", name: "Bradesco", compe: "237", color: "#cf2032" },
  { slug: "bradescoinfinite", name: "Bradesco Visa Infinite", compe: null, color: "#101010" },
  { slug: "brb", name: "BRB — Banco de Brasília", compe: "070", color: "#173e7d" },
  { slug: "brex", name: "Brex", compe: null, color: "#ffffff" },
  { slug: "bs2", name: "Banco BS2", compe: "218", color: "#3333cc" },
  { slug: "btgpactual", name: "BTG Pactual", compe: "208", color: "#001e61" },
  { slug: "btgultrablue", name: "BTG Pactual Ultrablue", compe: null, color: "#0a5fd9" },
  { slug: "bv", name: "Banco BV", compe: "655", color: "#5776d0" },
  { slug: "bybit", name: "Bybit", compe: null, color: "#ffffff" },
  { slug: "c6bank", name: "C6 Bank", compe: "336", color: "#000000" },
  { slug: "c6carbon", name: "C6 Carbon", compe: null, color: "#1c1c1c" },
  { slug: "c6global", name: "C6 Global", compe: null, color: "#0a2540" },
  { slug: "caixa", name: "Caixa Econômica Federal", compe: "104", color: "#ececfb" },
  { slug: "caju", name: "Caju", compe: null, color: "#ffffff" },
  { slug: "capitual", name: "Capitual", compe: null, color: "#ffffff" },
  { slug: "carrefour", name: "Cartão Carrefour", compe: null, color: "#ffffff" },
  { slug: "casasbahia", name: "Cartão Casas Bahia", compe: null, color: "#ffffff" },
  { slug: "cashapp", name: "Cash App", compe: null, color: "#ffffff" },
  { slug: "cea", name: "Cartão C&A", compe: null, color: "#000000" },
  { slug: "celcoin", name: "Celcoin", compe: "509", color: "#7664fa" },
  { slug: "citibank", name: "Citibank", compe: "745", color: "#255be3" },
  { slug: "cloudwalk", name: "CloudWalk", compe: "542", color: "#000000" },
  { slug: "coinbase", name: "Coinbase", compe: null, color: "#ffffff" },
  { slug: "colombo", name: "Cartão Colombo", compe: null, color: "#ffffff" },
  { slug: "contaazul", name: "Conta Azul", compe: null, color: "#ffffff" },
  { slug: "contasimples", name: "Conta Simples", compe: null, color: "#ffffff" },
  { slug: "contbank", name: "Contbank", compe: null, color: "#ffffff" },
  { slug: "cora", name: "Cora", compe: "403", color: "#fe3e6d" },
  { slug: "credisis", name: "CrediSIS", compe: "097", color: "#ffffff" },
  { slug: "creditas", name: "Creditas", compe: "342", color: "#8edb00" },
  { slug: "cresol", name: "Cresol", compe: "133", color: "#ef8124" },
  { slug: "cryptocom", name: "Crypto.com", compe: null, color: "#0a0e1a" },
  { slug: "daycoval", name: "Banco Daycoval", compe: "707", color: "#001c55" },
  { slug: "decolar", name: "Cartão Decolar", compe: null, color: "#ffffff" },
  { slug: "deutsche", name: "Deutsche Bank Brasil", compe: "487", color: "#0018a8" },
  { slug: "digimais", name: "Banco Digimais", compe: "654", color: "#171b3d" },
  { slug: "digio", name: "Digio", compe: "335", color: "#23292e" },
  { slug: "dinersclub", name: "Diners Club", compe: null, color: "#ffffff" },
  { slug: "discover", name: "Discover", compe: null, color: "#ffffff" },
  { slug: "dock", name: "Dock", compe: null, color: "#ffffff" },
  { slug: "edenred", name: "Edenred", compe: null, color: "#ffffff" },
  { slug: "efibank", name: "Efí Bank", compe: "364", color: "#f37124" },
  { slug: "fibra", name: "Banco Fibra", compe: "224", color: "#082a4d" },
  { slug: "fidelity", name: "Fidelity", compe: null, color: "#ee2722" },
  { slug: "flash", name: "Flash Benefícios", compe: null, color: "#fe2b8f" },
  { slug: "googlepay", name: "Google Pay", compe: null, color: "#ffffff" },
  { slug: "grafeno", name: "Grafeno", compe: null, color: "#ffffff" },
  { slug: "havan", name: "Cartão Havan", compe: null, color: "#00275e" },
  { slug: "hipercard", name: "Hipercard", compe: null, color: "#ffffff" },
  { slug: "honda", name: "Banco Honda", compe: null, color: "#da251d" },
  { slug: "ifood", name: "iFood Benefícios", compe: null, color: "#ea1d2c" },
  { slug: "ifoodpago", name: "iFood Pago", compe: null, color: "#ea1d2c" },
  { slug: "inbursa", name: "Banco Inbursa", compe: "012", color: "#012148" },
  { slug: "industrialdobrasil", name: "Banco Industrial do Brasil", compe: "604", color: "#001d5d" },
  { slug: "infinitepay", name: "InfinitePay", compe: null, color: "#171527" },
  { slug: "inter", name: "Banco Inter", compe: "077", color: "#ff7a00" },
  { slug: "interglobal", name: "Inter Global", compe: null, color: "#101010" },
  { slug: "itau", name: "Itaú Unibanco", compe: "341", color: "#fe6100" },
  { slug: "itaublack", name: "Itaú Black", compe: null, color: "#141414" },
  { slug: "itaupersonnalite", name: "Itaú Personnalité", compe: null, color: "#0c2b52" },
  { slug: "itautheone", name: "Itaú Personnalité The One", compe: null, color: "#101010" },
  { slug: "itauuniclass", name: "Itaú Uniclass", compe: null, color: "#1c4f82" },
  { slug: "iugu", name: "iugu", compe: "401", color: "#1b1b1b" },
  { slug: "jcb", name: "JCB", compe: null, color: "#ffffff" },
  { slug: "kabum", name: "Cartão KaBuM!", compe: null, color: "#000000" },
  { slug: "klarna", name: "Klarna", compe: null, color: "#ffffff" },
  { slug: "klavi", name: "Klavi", compe: null, color: "#ffffff" },
  { slug: "latampass", name: "Cartão LATAM Pass", compe: null, color: "#ffffff" },
  { slug: "leader", name: "Cartão Leader", compe: null, color: "#ed1c24" },
  { slug: "letsbank", name: "LetsBank", compe: "630", color: "#0d0d0d" },
  { slug: "linker", name: "Linker", compe: null, color: "#ffffff" },
  { slug: "livelo", name: "Cartão Livelo", compe: null, color: "#ffffff" },
  { slug: "maestro", name: "Maestro", compe: null, color: "#ffffff" },
  { slug: "magalupay", name: "MagaluPay", compe: "396", color: "#ffffff" },
  { slug: "marisa", name: "Cartão Marisa", compe: null, color: "#ec008c" },
  { slug: "mastercard", name: "Mastercard", compe: null, color: "#ffffff" },
  { slug: "meliuz", name: "Cartão Méliuz", compe: null, color: "#fd9cbf" },
  { slug: "mercadobitcoin", name: "Mercado Bitcoin", compe: null, color: "#ffffff" },
  { slug: "mercadopago", name: "Mercado Pago", compe: "323", color: "#00bcff" },
  { slug: "mercantil", name: "Banco Mercantil", compe: "389", color: "#1526ff" },
  { slug: "mizuho", name: "Banco Mizuho do Brasil", compe: "370", color: "#37498b" },
  { slug: "modobank", name: "Modobank", compe: null, color: "#ffffff" },
  { slug: "morganstanley", name: "Banco Morgan Stanley", compe: "066", color: "#ffffff" },
  { slug: "mufg", name: "Banco MUFG Brasil", compe: "456", color: "#e30613" },
  { slug: "multiplobank", name: "Múltiplo Bank", compe: null, color: "#ffffff" },
  { slug: "n26", name: "N26", compe: null, color: "#ffffff" },
  { slug: "neon", name: "Neon", compe: "735", color: "#00a8ef" },
  { slug: "neteller", name: "Neteller", compe: null, color: "#ffffff" },
  { slug: "next", name: "Next", compe: null, color: "#1e3c3c" },
  { slug: "ngcash", name: "NG.CASH", compe: null, color: "#000000" },
  { slug: "nomad", name: "Nomad", compe: null, color: "#ffce04" },
  { slug: "nubank", name: "Nubank", compe: "260", color: "#820ad1" },
  { slug: "nubankcroma", name: "Nubank Croma", compe: null, color: "#f2f0ef" },
  { slug: "nubankultravioleta", name: "Nubank Ultravioleta", compe: null, color: "#2b0a4d" },
  { slug: "okx", name: "OKX", compe: null, color: "#ffffff" },
  { slug: "omiecash", name: "Omie.Cash", compe: null, color: "#ffffff" },
  { slug: "omni", name: "Omni Banco", compe: "613", color: "#ffffff" },
  { slug: "onfly", name: "Onfly", compe: null, color: "#ffffff" },
  { slug: "original", name: "Banco Original", compe: "212", color: "#18ad47" },
  { slug: "originalblack", name: "Banco Original Black", compe: null, color: "#0a0a0a" },
  { slug: "originalgold", name: "Banco Original Gold", compe: null, color: "#b6903f" },
  { slug: "originalinternational", name: "Banco Original International", compe: null, color: "#145c30" },
  { slug: "originalplatinum", name: "Banco Original Platinum", compe: null, color: "#9a9a9d" },
  { slug: "orionpay", name: "OrionPay", compe: null, color: "#ffffff" },
  { slug: "ourinvest", name: "Banco Ourinvest", compe: "712", color: "#15252d" },
  { slug: "outros", name: "Outros", compe: null, color: "#9aa0a6" },
  { slug: "pagarme", name: "Pagar.me", compe: null, color: "#00af55" },
  { slug: "pagbank", name: "PagBank", compe: "290", color: "#1bb99a" },
  { slug: "pan", name: "Banco Pan", compe: "623", color: "#363636" },
  { slug: "paulista", name: "Banco Paulista", compe: "611", color: "#ffffff" },
  { slug: "paycash", name: "PayCash", compe: null, color: "#1c3256" },
  { slug: "payoneer", name: "Payoneer", compe: null, color: "#ffffff" },
  { slug: "paypal", name: "PayPal", compe: null, color: "#003087" },
  { slug: "pernambucanas", name: "Cartão Pernambucanas", compe: null, color: "#ffffff" },
  { slug: "picpay", name: "PicPay", compe: "380", color: "#11c76f" },
  { slug: "picpayblack", name: "PicPay Black", compe: null, color: "#101010" },
  { slug: "pinbank", name: "PinBank", compe: null, color: "#ffffff" },
  { slug: "pine", name: "Banco Pine", compe: "643", color: "#661739" },
  { slug: "pluggy", name: "Pluggy", compe: null, color: "#ffffff" },
  { slug: "pluxee", name: "Pluxee", compe: null, color: "#221c46" },
  { slug: "polishop", name: "Cartão Polishop", compe: null, color: "#ffffff" },
  { slug: "ponto", name: "Cartão Ponto", compe: null, color: "#ffffff" },
  { slug: "porto", name: "Porto", compe: null, color: "#00a1fc" },
  { slug: "portoblack", name: "Porto Bank Black", compe: null, color: "#101010" },
  { slug: "portoinfinite", name: "Porto Bank Infinite", compe: null, color: "#0d0d0d" },
  { slug: "qitech", name: "QI Tech", compe: "329", color: "#101828" },
  { slug: "qive", name: "Qive", compe: null, color: "#0f1115" },
  { slug: "qualitybank", name: "Quality Digital Bank", compe: null, color: "#ffffff" },
  { slug: "queroquero", name: "Cartão Quero-Quero", compe: null, color: "#ffffff" },
  { slug: "rabobank", name: "Banco Rabobank", compe: "747", color: "#283a93" },
  { slug: "rappicard", name: "Cartão RappiCard", compe: null, color: "#ffffff" },
  { slug: "recargapay", name: "RecargaPay", compe: null, color: "#053e6e" },
  { slug: "rendimento", name: "Banco Rendimento", compe: "633", color: "#0a1d6f" },
  { slug: "renner", name: "Cartão Renner", compe: null, color: "#d72027" },
  { slug: "revolut", name: "Revolut", compe: null, color: "#000000" },
  { slug: "riachuelo", name: "Cartão Riachuelo", compe: null, color: "#0c2e2d" },
  { slug: "rico", name: "Rico", compe: null, color: "#010042" },
  { slug: "ripio", name: "Ripio", compe: null, color: "#690ed8" },
  { slug: "robinhood", name: "Robinhood", compe: null, color: "#000000" },
  { slug: "safra", name: "Banco Safra", compe: "422", color: "#00003c" },
  { slug: "safrainfiniteiridium", name: "Safra Visa Infinite Metal Iridium", compe: null, color: "#8f9296" },
  { slug: "samsung", name: "Cartão Samsung", compe: null, color: "#000000" },
  { slug: "santander", name: "Santander", compe: "033", color: "#fe0000" },
  { slug: "santanderelite", name: "Santander Elite", compe: null, color: "#9a9a9d" },
  { slug: "santanderunique", name: "Santander Unique", compe: null, color: "#101010" },
  { slug: "schwab", name: "Charles Schwab", compe: null, color: "#00a0df" },
  { slug: "sicoob", name: "Sicoob", compe: "756", color: "#003641" },
  { slug: "sicoobverth", name: "Sicoob Verth", compe: null, color: "#0f4d2e" },
  { slug: "sicredi", name: "Sicredi", compe: "748", color: "#3fa110" },
  { slug: "sicrediinfinite", name: "Sicredi Visa Infinite", compe: null, color: "#16352a" },
  { slug: "sisprime", name: "Sisprime do Brasil", compe: "084", color: "#ffffff" },
  { slug: "skrill", name: "Skrill", compe: null, color: "#ffffff" },
  { slug: "socgen", name: "Banco Société Générale Brasil", compe: "366", color: "#ffffff" },
  { slug: "sofisa", name: "Banco Sofisa", compe: "637", color: "#17b497" },
  { slug: "square", name: "Square", compe: null, color: "#ffffff" },
  { slug: "squid", name: "Squid", compe: null, color: "#ffffff" },
  { slug: "starkbank", name: "Stark Bank", compe: null, color: "#1d2732" },
  { slug: "stellantis", name: "Banco Stellantis", compe: null, color: "#243882" },
  { slug: "stone", name: "Stone", compe: "197", color: "#0db14b" },
  { slug: "stripe", name: "Stripe", compe: null, color: "#635bff" },
  { slug: "sulcredi", name: "Sulcredi", compe: null, color: "#ffffff" },
  { slug: "sumitomo", name: "Banco Sumitomo Mitsui Brasileiro", compe: "464", color: "#ffffff" },
  { slug: "sumup", name: "SumUp", compe: null, color: "#ffffff" },
  { slug: "swile", name: "Swile", compe: null, color: "#000000" },
  { slug: "ticket", name: "Ticket", compe: null, color: "#ffffff" },
  { slug: "ton", name: "Ton", compe: null, color: "#0dea4a" },
  { slug: "topazio", name: "Banco Topázio", compe: "082", color: "#50c3c7" },
  { slug: "toro", name: "Toro Investimentos", compe: "352", color: "#000000" },
  { slug: "toyota", name: "Banco Toyota", compe: "387", color: "#eb0a1e" },
  { slug: "transfeera", name: "Transfeera", compe: null, color: "#ffffff" },
  { slug: "tribanco", name: "Tribanco", compe: "634", color: "#00336d" },
  { slug: "unicred", name: "Unicred", compe: "136", color: "#004a35" },
  { slug: "unionpay", name: "UnionPay", compe: null, color: "#ffffff" },
  { slug: "uniprime", name: "Uniprime", compe: "099", color: "#ffffff" },
  { slug: "uzzipay", name: "UzziPay", compe: null, color: "#53a000" },
  { slug: "venmo", name: "Venmo", compe: null, color: "#ffffff" },
  { slug: "visa", name: "Visa", compe: null, color: "#ffffff" },
  { slug: "visaelectron", name: "Visa Electron", compe: null, color: "#ffffff" },
  { slug: "volkswagen", name: "Banco Volkswagen", compe: "393", color: "#001e50" },
  { slug: "vrbeneficios", name: "VR Benefícios", compe: null, color: "#00a413" },
  { slug: "warren", name: "Warren Investimentos", compe: "371", color: "#e24324" },
  { slug: "willbank", name: "Will Bank", compe: null, color: "#ffd900" },
  { slug: "wise", name: "Wise", compe: null, color: "#9fe870" },
  { slug: "xp", name: "XP", compe: "348", color: "#000000" },
  { slug: "xpglobal", name: "XP Global", compe: null, color: "#101010" },
  { slug: "zelle", name: "Zelle", compe: null, color: "#ffffff" },
  { slug: "zema", name: "Cartão Zema", compe: null, color: "#ffffff" },
  { slug: "zemobank", name: "Zemo Bank", compe: null, color: "#001041" },
  { slug: "zrobank", name: "Zro Bank", compe: null, color: "#252f59" },
];

const normalize = (s: string): string =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

/** Busca pelo código COMPE do Bacen. Aceita "341", 341 ou "77" (completa os zeros). */
export function getBankByCompe(compe: string | number): BankData | undefined {
  const c = String(compe).trim().padStart(3, "0");
  return banksData.find((b) => b.compe === c);
}

/** Busca pelo slug exato (ex.: "nubank", "bancodobrasil"). */
export function getBankBySlug(slug: string): BankData | undefined {
  const s = normalize(slug);
  return banksData.find((b) => b.slug === s);
}

/**
 * Busca pelo nome, ignorando acentos e maiúsculas ("itaú unibanco" === "Itau Unibanco").
 * Se não houver correspondência exata, tenta correspondência parcial ("itau" → Itaú Unibanco).
 */
export function getBankByName(name: string): BankData | undefined {
  const n = normalize(name);
  if (!n) return undefined;
  return (
    banksData.find((b) => normalize(b.name) === n) ??
    banksData.find((b) => normalize(b.name).includes(n) || b.slug.includes(n.replace(/\s+/g, "")))
  );
}

/** Busca livre por nome, slug ou COMPE; retorna todas as correspondências. */
export function searchBanks(query: string): BankData[] {
  const q = normalize(query);
  if (!q) return [];
  return banksData.filter(
    (b) =>
      normalize(b.name).includes(q) ||
      b.slug.includes(q.replace(/\s+/g, "")) ||
      (b.compe ?? "").includes(q)
  );
}
